export const IMPLEMENTATION_PACKAGES = [
  {
    id: "operator",
    name: "Operator Implementation",
    price: "$2,500",
    items: [
      "Configure ArosFlow around your existing acquisition workflow",
      "Set editable underwriting assumptions and offer rules with existing tools",
      "Set up the existing buyer database and buy boxes",
      "Calibrate up to 10 of your live or example deals",
      "One live onboarding and training session",
      "Written acquisition workflow / SOP handoff",
      "30 days of implementation support",
    ],
  },
  {
    id: "team",
    name: "Acquisition Team Implementation",
    price: "$5,000",
    items: [
      "Everything in Operator Implementation",
      "Deeper process mapping and underwriting guardrails",
      "Calibrate up to 25 deals",
      "Set up buyer / disposition workflow with existing capabilities",
      "Up to 3 stakeholder training sessions",
      "45 days of implementation support",
    ],
  },
] as const;
